// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"2cf6ce5c","137":"ea075dfe","227":"ea13097c","383":"854bc3cb","401":"23136b5f","464":"e45b49f8","551":"379fab3f","567":"08f4241d","608":"413f0508","669":"b57406a1","700":"9cd498f6","802":"f720982e","894":"770cb49c"}[chunkId] + ".chunk.js";
};